import React, { useEffect, useRef, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(1.5),
    textAlign: "center",
    height: "100%",
    boxSizing: "border-box"
  },
  value: {
    fontWeight: 700
  }
}));

const CARD_DEFS = [
  { key: "pending", labelKey: "tasks.summary.pending" },
  { key: "inProgress", labelKey: "tasks.summary.inProgress" },
  { key: "done", labelKey: "tasks.summary.done" },
  { key: "canceled", labelKey: "tasks.summary.canceled" },
  { key: "openTotal", labelKey: "tasks.summary.openTotal" },
  { key: "overdue", labelKey: "tasks.summary.overdue" },
  { key: "dueSoon", labelKey: "tasks.summary.dueSoon" }
];

// Cards de resumo — busca GET /tasks/summary (o backend é a única fonte de
// verdade sobre o que este usuário pode ver). Recarrega sempre que
// `refreshToken` muda (montagem inicial e sinais de tempo real
// consolidados pela página pai — este componente nunca escuta o socket
// diretamente, conforme decidido: o tratamento do evento é centralizado
// em pages/Tasks/index.js).
const TaskSummaryCards = ({ refreshToken }) => {
  const classes = useStyles();
  const [summary, setSummary] = useState(null);

  const isMountedRef = useRef(true);
  const requestIdRef = useRef(0);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const currentRequestId = ++requestIdRef.current;

    (async () => {
      try {
        const { data } = await api.get("/tasks/summary");
        if (!isMountedRef.current || currentRequestId !== requestIdRef.current) return;
        setSummary(data);
      } catch (err) {
        if (!isMountedRef.current || currentRequestId !== requestIdRef.current) return;
        toastError(err);
      }
    })();
  }, [refreshToken]);

  if (!summary) return null;

  return (
    <Grid container spacing={1} className={classes.container}>
      {CARD_DEFS.map(card => (
        <Grid item xs={6} sm={4} md key={card.key}>
          <Paper className={classes.paper} variant="outlined">
            <Typography variant="caption" color="textSecondary">
              {i18n.t(card.labelKey)}
            </Typography>
            <Typography variant="h6" className={classes.value}>
              {summary[card.key]}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default TaskSummaryCards;
